var _style, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.6 54.5",
    style: {
      enableBackground: "new 0 0 85.6 54.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000102532646973098363650000014197394713783972269_);}\r\n\t.st2{fill:url(#SVGID_00000076578768132157578730000001579358450760687264_);}\r\n\t.st3{fill:url(#SVGID_00000149364846306234945950000000395677400313089452_);}\r\n\t.st4{fill:url(#SVGID_00000171703293204152141470000015843676665420628143_);}\r\n\t.st5{fill:url(#SVGID_00000103955558018752201190000013013061822067464635_);}\r\n\t.st6{fill:url(#SVGID_00000142870144413301333410000002054040555437467068_);}\r\n\t.st7{fill:#E259A0;}\r\n\t.st8{fill:#C43492;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.1248,
    y1: -2.7086,
    x2: 29.1248,
    y2: 37.7758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.7,13.6 42.6,33.7 42.6,47.8 15.7,39.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063628703103720695210000016733495813612319153_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.0518,
    y1: -2.7086,
    x2: 56.0518,
    y2: 37.7758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000063628703103720695210000016733495813612319153_)"
    },
    points: "61.5,13.6 42.6,33.7 42.6,47.8  69.5,39.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093883164002612763840000005856793178803465901_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.5882,
    y1: 46.4807,
    x2: 42.5882,
    y2: 53.5303
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 47.8,
    style: {
      fill: "url(#SVGID_00000093883164002612763840000005856793178803465901_)"
    },
    width: 47.3,
    height: 5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000942586118022306840000013241096164705480619_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.5882,
    y1: 9.6591,
    x2: 42.5882,
    y2: 53.5808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000942586118022306840000013241096164705480619_)"
    },
    points: "56.9,32 42.6,7 28.2,32 6.4,16.9  18.9,47.8 42.6,47.8 66.2,47.8 78.8,16.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011744971977076288630000016119340681544663982_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.5882,
    y1: 0.9456,
    x2: 42.5882,
    y2: 11.6267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011744971977076288630000016119340681544663982_)"
    },
    d: "M48.1,7c0-3.1-2.5-5.5-5.5-5.5 c-3.1,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5C45.6,12.6,48.1,10.1,48.1,7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096737709435520449510000016300282429141686954_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.8265,
    y1: 11.3455,
    x2: 78.8265,
    y2: 23.2775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096737709435520449510000016300282429141686954_)"
    },
    d: "M84.4,16.9c0-3.1-2.5-5.5-5.5-5.5 c-3.1,0-5.5,2.5-5.5,5.5c0,3.1,2.5,5.5,5.5,5.5C81.9,22.4,84.4,19.9,84.4,16.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134239676780884175550000009721722813701058746_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.35,
    y1: 10.7834,
    x2: 6.35,
    y2: 21.7492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128205,
    style: {
      stopColor: "#FFD02C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1633,
    style: {
      stopColor: "#FEC529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#F9A220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7941D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134239676780884175550000009721722813701058746_)"
    },
    d: "M11.9,16.9c0-3.1-2.5-5.5-5.5-5.5 c-3.1,0-5.5,2.5-5.5,5.5c0,3.1,2.5,5.5,5.5,5.5C9.4,22.4,11.9,19.9,11.9,16.9z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "42.6,27.4 37.9,34.9 42.6,42.4 47.3,34.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "42.6,27.4 41.8,34.9 42.6,42.4 47.3,34.9  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.ab0de2a711e5ad1a20dc2846e89be610.svg";
export { ForwardRef as ReactComponent };